module.exports = __webpack_public_path__ + "img/wafa.81136b34.png";